export enum EJobType {
  BUSINESS_MANAGEMENT = 1, // 경영기획, 지원
  MARKETING, // 홍보/마케팅
  SALES, // 영업
  PRODUCTION_MANAGEMENT, // 생산 유통 품질
  CONSTRUCTION = 6, // 건설 엔지니어
  RND, // 연구/개발
  IT, // IT 서비스
  DESIGN, // 디자인
  FINANCE, // 금융 보험
  CUSTOMER_SUPPORT, // 서비스 고객지원
  HEALTHCARE, // 의료 보건
}

export enum JobTypeCode {
  NEW = 'NEW',
  CAREER = 'CAREER',
  INTERNSHIP = 'INTERNSHIP',
}

interface IQuestionGuide {
  question: string;
  guide: string;
}

export interface IJobQuestion {
  knowledge: IQuestionGuide[];
  attitude: IQuestionGuide[];
}

export const JobQuestionGuides: Record<EJobType, IJobQuestion> = {
  [EJobType.SALES]: {
    knowledge: [
      {
        question: '영업이란 무엇이라고 생각하나요?',
        guide:
          '구체적으로 영업 직무에서 어떤 일을 하는지 미리 파악해두면 도움이 됩니다. 잘 알고 있다고 생각하지만, 면접관들 입장에서는 지원자들이 피상적으로 알고 있다고 느껴질 때가 많습니다. 고민의 깊이를 보여주세요.',
      },
      {
        question: '영업을 잘하기 위해서는 무엇이 중요하다고 생각하나요?',
        guide:
          '"사람 만나는 것이 좋다"는 것은 식상할 수 있는 답변입니다. 영업은 목적이 있는 관계라는 것을 염두에 두고 충분히 고민하는 것이 필요합니다. 특히, 산업이나 제품에 따라 차이가 날 수 있는 부분을 미리 알아보고 준비하는 것이 좋습니다.',
      },
      {
        question: '실제로 고객을 만나면 어떤 방식으로 영업을 하시겠습니까? (온라인과 오프라인 구분)',
        guide:
          '전략적으로 영업에 임하는 것이 중요합니다. 특히 세심하고 구체적인 사항까지 언급을 한다면, 면접관들에게 좋은 인상을 남길 수 있습니다. 최근에는 온라인으로 고객들을 만나는 경우가 많이 있기 때문에 미리 준비를 하면 더 좋습니다.',
      },
    ],
    attitude: [
      {
        question: '어떤 사람과 좋은 관계를 유지하기 위해 가장 중요한 것은 무엇입니까?',
        guide:
          "영업에서 좋은 관계가 무엇인지에 대해 스스로 정의해보는 것이 필요합니다. 영업적인 성과를 만들 수 있는 관계라는 점을 염두에 두고 고민하면 좋습니다. 중요한 것의 정답을 맞추는 것이 아니기 때문에 '왜' 그렇게 생각했는지 설명하는 것에 집중하세요.",
      },
      {
        question: '다른 사람을 설득했던 경험에 대해 말씀해 주세요.',
        guide:
          '많은 지원자들이 어떻게 설득을 했는지에 대한 설명에 초점을 맞추곤 합니다. 물론 과정을 설명하는 것도 중요하지만, 당시의 상황, 상대방의 반응이나 특징이 어땠는지와 이를 통해 어떤 판단을 했는지도 함께 설명하는 것이 필요합니다.',
      },
      {
        question: '자신이 영업을 잘할 수 있는 이유는 무엇입니까?',
        guide:
          '영업을 잘할 수 있는 이유에 대해 자신의 강점이 실제로 어떻게 발현될 것인지 설명하면 좋습니다. 그리고 정말 중요한 것은 실제로 자신감 있는 태도가 전달되는 것입니다. 잘할 수 있는 이유를 말하면서 소극적인 모습을 보이면 어색하게 느껴질 것입니다.',
      },
    ],
  },
  [EJobType.RND]: {
    knowledge: [
      {
        question: '자신이 가진 지원분야에 적합한 지식이나 기술에 대해 말씀해 주세요.',
        guide:
          '연구/개발분야는 지원하는 기업과 직무에 대해 구체적으로 파악한 상태에서 면접에 임하는 것이 매우 중요합니다. 관심을 표현하는 것을 위해서가 아닌, 실무적으로 요구하는 지식과 기술이 무엇인지를 잘 설명하기 위해서 입니다.',
      },
      {
        question: '가장 관심 있는 연구 주제나 분야와 그 이유는 무엇인가요?',
        guide:
          '보통 두 가지 관점에서 질문을 합니다. 지원 기업에서 추구하는 방향과 일치하는지, 그리고 지속적으로 해당 분야에 관심과 학습을 하고 있는지 입니다. 다만, 모르는 것까지 아는 척하면 답변하는 것은 쉽게 알아챌 수 있고 큰 도움이 되지 않습니다.',
      },
      {
        question: '현재 사회적으로 각광 받는 기술과 그 이유는 무엇인가요?',
        guide:
          '기업은 실용적인 결과를 만드는 것이 중요합니다. 어떤 기술이 실질적으로 만들어낼 수 있는 가치가 무엇인지 설명하는 것이 중요합니다. 새로운 기술에 대해 알고 있는 것도 중요하지만, 실제로 어떻게 활용할 수 있는지 등에 답변할 수 있으면 좋습니다.',
      },
    ],
    attitude: [
      {
        question: '입사 전에 기대했던 업무와 차이가 난다면 어떻게 하시겠습니까?',
        guide:
          '입사 전에 공부를 할 때는 다양한 것에 관심을 둘 수 있습니다. 그러나 기업에서는 전체 목표를 달성하는 것이 중요하기 때문에 재밌는 것만 하는 것이 어렵습니다. 특히 입사 초반에는 더 어려울 수 있습니다. 이를 고려하여 답변을 하는 것이 좋습니다.',
      },
      {
        question: '지속적으로 자기 개발을 위해 하고 있는 활동이 있나요?',
        guide:
          '전문적인 지식이나 기술은 지속적으로 발전하고, 빠르게 변화합니다. 어떻게 자기개발을 하고 있는지가 영향을 주는 것은 아니지만, 지원자가 앞으로 꾸준히 노력을 할 것인지 예상해보는 것은 면접관에게 중요합니다.',
      },
      {
        question: '자신의 능력이 어느 정도 수준이라고 생각하시나요?',
        guide:
          '겸손하게 대답을 해야 하는지, 자신감을 표현해야 하는지 고민이 될 수 있습니다. 그럴 때는 비교가 가능한 사람이나 수준을 정하는 것이 좋습니다. 이렇게 하면, 구체적이면서 앞으로 개선을 통해 달성할 수 있는 수준이 명확해집니다.',
      },
    ],
  },
  [EJobType.IT]: {
    knowledge: [
      {
        question: '기획/개발 업무를 위해 가장 중요한 것이 무엇이라고 생각하시나요?',
        guide:
          '기획이나 개발 업무의 특성을 바탕으로 설명하면 도움이 됩니다. 특히, 이와 같은 질문들은 두괄식으로 답변하는 것이 좋습니다. 명확하게 중요한 것을 답변하고, 부족한 것은 부연 설명을 하면 듣는 사람이 이해가 쉽습니다.',
      },
      {
        question: '지원 회사의 제품/서비스에 대해 어떻게 생각하시나요?',
        guide:
          '이 분야에서는 지원 회사의 제품이나 서비스에 대해 잘 알고 있는 것이 중요합니다. 현재 기업에서 어떤 고민을 하고 있을지에 대해 생각해보는 것이 많은 도움이 됩니다. 특히, 일반적인 고객 입장과 기업의 입장을 구분하여 생각하면 좋습니다.',
      },
      {
        question: '프로젝트 경험과 자신이 기여한 것에 대해 말씀해 주세요.',
        guide:
          '프로젝트 경험은 IT 서비스에서 중요합니다. 이 분야에 대한 애정을 보여줄 수 있다고 생가되기 때문입니다. 단, 프로젝트 경험이 없어서 면접 답변을 회피하는 것보다 대체할 수 있는 경험을 준비하고, 직무와의 관련성을 표현하는 것이 좋습니다.',
      },
    ],
    attitude: [
      {
        question: '고객 관점에서 사고한다는 것이 무엇이라고 생각하시나요?',
        guide:
          '고객의 입장에서 제품/서비스를 바라보는 것은 매우 중요합니다. 따라서 미리 답변을 준비해야 합니다. 면접관의 입장에서 왜 이 질문을 하는지 생각해보는 것에서 출발하면 도움이 됩니다. 핵심은 여러 이유보다 본질적인 하나의 이유가 중요하다는 것입니다.',
      },
      {
        question: '지원 직군에 자신이 적합하다고 생각하는 이유는 무엇입니까?',
        guide:
          '지원 직군에 자신이 적합한 이유는 면접관들이 자주 하는 질문이지만, 변별력을 갖기 어렵기도 합니다. 그래서 최고의 답변을 위해 억지로 끼워맞춘 듯한 인상을 주는 내용보다 진정성 있는 태도가 중요합니다.',
      },
      {
        question: '업무를 수행하기 위해 가장 부족한 부분과 개선 방법은 무엇입니까?',
        guide:
          "지원자들 간의 약점이나 단점에 대한 답변은 별반 차이가 없습니다. '너무 꼼꼼한 것이 단점이다'와 같은 유형은 흔합니다. 다른 사람들과 협업하는데 문제가 있는 것이 아니라면, 상대방이 문제라고 느끼지 않는 정도로 솔직하게 표현하는 것도 괜찮습니다.",
      },
    ],
  },
  [EJobType.BUSINESS_MANAGEMENT]: {
    knowledge: [
      {
        question: '입사를 하게 되면, 가장 어려운 일이 무엇이라고 예상하시나요?',
        guide:
          "누구나 지원할 수 있는 분야이지만, 최근에는 지속적인 관심을 갖고 있는 지원자를 선호하는 편입니다. 질문에 답변을 할 때 중요한 것은 얼마나 구체적이고 자세히 알고 있는지 입니다. 면접관이 '얼마 전에 그런 일이 있었는데'한다면 성공적일 것입니 다.",
      },
      {
        question: '지원 회사의 미래 비전을 고려할 때, 어떤 방향으로 목표를 수립해야 할까요?',
        guide:
          '경영기획 및 지원 직군의 여러 질문들은 조직의 관점에서 생각을 시작하는 것이 도움이 됩니다. 신문기사나 인터뷰 자료들을 활용하여 경영자의 입장에서 생각해보면 좋습니다. 그리고 지원분야의 업무가 어떻게 기여할 수 있는지도 언급하면 좋습니다.',
      },
      {
        question: '지원분야에서 가장 화두가 되고 있는 것에 대해 말씀해 주세요.',
        guide:
          '언론을 통해 다루어지는 내용들은 해당 시점에 기업에서 고민하고 있는 주제들이 많이 있습니다. 따라서 현업에서 어떤 고민을 하게 될것인지를 염두에 두고 답변을 하면 좋습니다. 면접관들의 고민에 공감을 해주는 것도 도움이 될 것입니다.',
      },
    ],
    attitude: [
      {
        question: '지원동기에 대해 말씀해 주세요.',
        guide:
          '경영기획/지원 분야는 지원동기에 대한 답변이 생각보다 쉽지 않습니다. 면접관들 입장에서도 비슷한 답변을 듣게 되는 경우가 많습니다. 단, 일부러 독특한 답변을 할 필요는 없습니다. 직무와 연결시킬 수 있는 일관된 경험과 관심을 강조하면 도움이  됩니다.',
      },
      {
        question: '본인이 업무를 수행하는데 있어서 강점이라고 생각하는 것은 무엇인가요?',
        guide:
          '지원분야에서 중요한 업무를 구체적으로 파악하고, 그것을 언급하면서 강점을 설명해준다면 듣는 사람이 강점을 쉽게 이해할 수 있습니다. 두리뭉실한 표현보다는 명확한 단어와 설명을 통해 설명을 하면 좋습니다.',
      },
      {
        question: '조직의 목표와 개인의 목표를 일치시키기 위해서는 어떻게 해야 할까요?',
        guide:
          '왜 이 질문을 하는지 생각해보면 도움이 됩니다. 개인의 생각은 모두 다르지만, 조직은 하나의 목표를 지향합니다. 개인과 조직의 목표가 상충될 수 있는 상황을 떠올려보고, 개인이 노력해야 하는 것과 조직이 환경을 만들어야 하는 것을 생각해보세요.',
      },
    ],
  },
  [EJobType.PRODUCTION_MANAGEMENT]: {
    knowledge: [
      {
        question: '지원분야와 관련된 지식 중에 가장 자신있는 것에 대해 설명해 주세요.',
        guide:
          '면접관에게 잘 보이기 위해 흥미롭지만 잘 모르는 것을 이야기하면 당황하는 순간이 있을 수 있습니다. 가장 잘 알고 있는 것, 지원분야에서 중요한 것, 아직은 부족한 것 등을 구분해서 답변하는 것이 필요합니다.',
      },
      {
        question: '지원분야에서 하는 일에 대해 알고 있는 것을 말씀해 주세요.',
        guide:
          '관련 전공이나 자격증 취득을 위해 공부를 했다고 지원분야의 일을 잘 안다고 하기는 어렵습니다. 실제 현업에서 어떤 일을 하는지 구체적으로 찾아보는 것이 도움이 됩니다. 지원자들이 알기 어렵다는 것을 알면서도 면접관은 구체적인 답변을 기대하게 됩니다.',
      },
      {
        question: '지원분야에서의 혁신을 위해 무엇이 필요하다고 생각하시나요.',
        guide:
          '현재 예상되는 문제점이라고 생각하는 것과 잘하고 있지만 더 잘하기 위해 혁신해야 하는 것을 구분해보면 생각하는데 도움이 됩니다. 자신이 알고 있는 지식을 자랑하기 위한 것보다 실무자의 입장에서 무엇이 필요할 것인가를 생각하면 좋습니다.',
      },
    ],
    attitude: [
      {
        question: '갑작스럽게 발생할 수 있는 문제에 대처하는 자신의 방법에 대해 말씀해 주세요.',
        guide:
          '보통 면접관들의 질문에는 현재 자신의 고민이나 생각이 묻어나게 됩니다. 갑작스러운 일들이 실제로 있을 수 있다는 의미일수도 있습니다. 현업에서 발생할 수 있는 것을 상상해보고 비유적으로 설명하면 듣는 사람 입장에서 이해가 잘 될 수 있습니다.',
      },
      {
        question: '계획을 잘 수립할 수 있는 방법은 무엇일까요?',
        guide:
          "면접의 답변에는 '강약'이 필요합니다. 계획의 절차를 나열하듯 이야기 하는 것보다, 절차 중에 중요하다고 생각하는 것을 분명하게 강조하고 그 이유를 설명하는 것이 도움이 됩니다. 또한 자신의 경험이 녹아있는 답변이라면 더 좋습니다.",
      },
      {
        question: '얼마나 성실하고 꼼꼼한 성격인가요?',
        guide:
          '내가 주변 사람들을 볼 때, 어떤 사람을 성실하고 꼼꼼하다고 생각하는지를 떠올려 보는 것이 도움이 됩니다. 그리고 막연하게 주장하는 것보다 자신의 일관된 행동과 경험에 대한 사례를 이야기하면 좋습니다.',
      },
    ],
  },
  [EJobType.MARKETING]: {
    knowledge: [
      {
        question: '지원 기업의 제품을 홍보/마케팅 할 수 있는 아이디어를 말씀해 주세요.',
        guide:
          '지원 기업에 대한 이해가 선행되는 것이 필요합니다. 특히, 주요 고객층을 고려하여 답변하는 것이 도움이 됩니다. 또한 홍보/마케팅의 목적을 미리 설정하고 자신의 생각을 풀어낸다면 듣는 사람에게 전달이 잘 될 것입니다.',
      },
      {
        question: 'MZ 세대에게 가장 적합한 홍보/마케팅 방법은 무엇일까요?',
        guide:
          '고객층을 바꿔서 질문할 수도 있기 때문에 고객의 특성을 얼마나 잘 파악하고 있는지가 중요합니다. 특성을 한 단어로 설명할 수 있으면 더 명확하게 느껴질 수 있습니다. 평소에 다양한 집단의 특성을 어떻게 파악할 수 있는지 준비하는 것이 필요합니다.',
      },
      {
        question: '타깃 고객은 어떻게 정하는 것이 가장 좋을까요?',
        guide:
          '타깃 고객은 현재 가장 많이 이용하는 고객과 앞으로 이용을 하도록 만들고 싶은 고객을 구분하면 도움이 됩니다. 그리고 신제품인지, 제품의 강점은 무엇인지, 조직의 비전은 무엇인지 등을 종합적으로 고려하면 좋은 인상을 남길 수 있습니다.',
      },
    ],
    attitude: [
      {
        question: '홍보/마케팅에서 무엇이 가장 중요하다고 생각하시나요?',
        guide:
          '지원 기업에서 필요하다고 생각하는 것과 스스로 강점이라고 생각하는 것을 연결시켜서 답변을 하는 것이 도움이 됩니다. 이와 같은 질문에 답변을 위해서는 평소에 생각을 정리해두는 것이 좋습니다. 기본적인 답변은 미리 준비해 주세요.',
      },
      {
        question: '기억에 남는 광고는 어떤 것이 있고, 그 이유는 무엇인가요?',
        guide:
          '면접관들은 기억에 남는 광고가 지원자가 좋아하는 유형의 아이디어라고 여길 가능성이 높습니다. 따라서 단순히 재밌었던 것을 이야기하는 것보다 지원기업의 제품이나 서비스와 연계하여 답변할 수 있는 것이 도움이 됩니다.',
      },
      {
        question: '도메인 지식이 많은 사람과 홍보/마케팅 지식이 많은 사람 중에서 누가 일을 잘 할까요?',
        guide:
          '정답은 없지만, 홍보/마케팅에서 창의성만으로 좋은 성과를 만들어내기 어렵다는 것을 생각해보면 도움이 됩니다. 사람들의 머릿속에 광고만 기억되는 것이 아니라 제품과 서비스가 각인되는 것이 중요합니다. 따라서 지원 기업에 대한 정보를 숙지하면  좋습니다.',
      },
    ],
  },
  [EJobType.CUSTOMER_SUPPORT]: {
    knowledge: [
      {
        question: '서비스 마인드라는 것은 무엇이라고 생각하나요?',
        guide:
          '익숙한 용어라도 갑작스럽게 물어보면 당황할 수 있습니다. 특히 너무 당연하게 사용하는 단어에 대해 자신만의 정의를 내리는 것은 갑자기 떠올리기 어려울 수 있습니다. 따라서 자신이 지원하는 분야에서 필수적인 것은 미리 준비하는 것이 필요합니다.',
      },
      {
        question: '고객의 갑질에 기업은 어떻게 대처해야 할까요?',
        guide:
          "고객이 왕이다'라는 말도 있지만, 요즘은 고객들의 불합리한 요구에는 적절한 대응을 하는 것이 필요하다는 인식도 있습니다. 중요한 것은 기업의 이미지와 고객의 인식에 부정적인 영향을 주지 않는 방법에 대한 것입니다.",
      },
      {
        question: '상대방이 신뢰감을 느낄 수 있는 말투와 행동은 어떤 것이 있을까요?',
        guide:
          '이 분야에서는 겉으로 드러나는 모습이 중요합니다. 따라서 면접에서는 말과 행동이 일치하는 것이 필요합니다. 정확한 발음이 중요하다고 했는데, 면접에서 발음이 부정확하다면 면접관들에게 좋은 인상을 남기기 어려울 수 있습니다.',
      },
    ],
    attitude: [
      {
        question: '자신만의 스트레스 해소법이 있으신가요?',
        guide:
          '스트레스를 해소하는 방법 자체가 중요한 것은 아닙니다. 스트레스를 계속 쌓아두는 것이 아니라 회복할 수 있는 능력도 있다는 것을 보여주는 것이 중요합니다. 회복탄력성과 관련된 정보를 찾아보는 것도 도움이 됩니다.',
      },
      {
        question: '소통이 원활하지 않은 사람과 어떻게 대화해야 할까요?',
        guide:
          '사례를 통해 깨달은 것을 설명하는 것이 도움이 됩니다. 특히, 면접관들이 공감할 수 있도록 많은 사람들이 동의하거나 일반적인 상황이면 좋습니다. 고객들의 반응은 다양할 수 있으니 평소에도 여러 사람들과 소통을 하는 것이 도움이 됩니다.',
      },
      {
        question: '지원 직군을 선택한 이유는 무엇인가요?',
        guide:
          '거창한 이유를 말해야 하는 것은 아닙니다. 다만 면접관들은 지원자가 쉽게 그만두는 것은 아닐지 걱정하기도 합니다. 따라서 쉽게 결정한 것이 아니라는 것도 잘 설명하는 것이 도움이 될 수 있습니다.',
      },
    ],
  },
  [EJobType.HEALTHCARE]: {
    knowledge: [
      {
        question: '지원 분야와 관련된 경험은 무엇이 있나요?',
        guide:
          '해당 분야는 관련 경험이 중요합니다. 신입 채용의 경우 실습 경험도 포함됩니다. 경험이 많은 것은 이력서를 통해 자연스럽게 전달할 수 있습니다. 중요한 것은 경험을 통해 배운 것과, 앞으로 지원 기업에서 어떻게 활용할 수 있는지를 설명하는 것입니다.',
      },
      {
        question: '지원 분야에서 일하는 것의 강점과 약점은 무엇인가요?',
        guide:
          '지원 분야에 대한 강/약점에 대한 질문은 지원자의 전반적인 이해 수준을 파악하려는 의도를 갖고 있는 경우가 있습니다. 또한 지원자가 지원 기업에서 잘 적응할 수 있을지에 대한 판단도 이루어지기도 합니다. 그래서 지원동기와 연결시킬 수 있어야 합니다.',
      },
      {
        question: '지원 분야와 관련하여 가장 잘 할 수 있는 일은 무엇인가요?',
        guide:
          '지원 기업과 직무에서 요구하는 지식이나 기술, 능력이 무엇인지 사전에 꼼꼼하게 파악하는 것이 도움이 됩니다. 그리고 자신의 경험과 지식 중에 가장 잘 부합하는 것에 대해 미리 생각을 정리하고 면접에 임하면 좋습니다.',
      },
    ],
    attitude: [
      {
        question: '지원 분야에서 예상되는 업무 중에 가장 힘들 것 같은 것은 무엇인가요?',
        guide:
          '주변의 선배나 현직자들에게 현실적인 어려움에 대해 파악하는 것이 도움이 됩니다. 면접관들도 이와 같은 것을 충분히 알고 있는 상태에서 질문을 할 가능성이 높습니다. 그리고 일반적인 것과 본인에게만 해당하는 것을 구분해서 답변하는 것도 도움이 됩니다.',
      },
      {
        question: '우리 회사를 선택한 이유는 무엇인가요?',
        guide:
          '지원 기업을 선택한 이유는 두괄식으로 명확하게 표현하는 것이 좋습니다. 또한 다른 기업 등과 비교하여 설명한다면, 지원 기업에 대한 관심과 애정을 설명하는데 도움이 될 수 있습니다. 지원 기업의 강점을 중심으로 미리 고민하는 것이 필요합니다.',
      },
      {
        question: '실수를 하지 않기 위한 자신만의 방법이 있나요?',
        guide:
          '개인의 실수가 미치는 영향을 클 수 있는 분야입니다. 실수를 줄이는 것은 실제 업무를 할 때 중요하기 때문에 평소에 방법을 찾아보고 실천하는 것이 필요합니다. 경험하지 않은 방법은 면접관들의 추가적인 질문에 답변이 어려울 수 있습니다.',
      },
    ],
  },
  [EJobType.CONSTRUCTION]: {
    knowledge: [
      {
        question: '수강 과목 중에 가장 재미있거나 자신 있는 것은 무엇인가요?',
        guide:
          '지원동기와 연결시켜서 생각해보는 것이 도움이 됩니다. 좋아하는 것과 잘할 수 있는 것, 그리고 기업에서 해야할 것이 무엇인지 미리 고민하면서 교집합을 파악하는 것이 도움이 될 수 있습니다.',
      },
      {
        question: '가장 최신의 기술적 트렌드는 무엇이 있나요?',
        guide:
          '많은 기업들이 지원분야에 대한 충분한 이해와 지식이 있는 지원자를 선호하고 있습니다. 최신의 기술적 트렌드는 지속적인 학습과 흥미를 보여줄 수 있는 부분이기 때문에 평소에 준비를 하는 것이 좋습니다. 특히 지원 기업에 필요한 것이면 더 좋습니 다.',
      },
      {
        question: '지원 분야는 미래에 어떤 모습으로 발전할 것이라고 생각하시나요?',
        guide:
          '산업에 대한 전반적인 이해와 기업에 대한 관심을 보여줄 수 있는 질문입니다. 즉흥적으로 답변하거나 너무 준비된 답변이라는 인상을 주지 않도록 자연스럽게 말할 수 있을 때까지 연습을 하는 것이 도움이 됩니다.',
      },
    ],
    attitude: [
      {
        question: '가장 힘든 일을 극복했던 경험에 대해 말씀해 주세요.',
        guide:
          "힘든 일'보다는 '극복'이라는 단어에 초점을 두고 생각하는 것이 도움이 됩니다. 억지로 힘든 일을 만드는 것보다 그것을 극복할 수 있는 사람이라는 것을 전달해야 합니다. 이 때, 자신감 있는 태도도 간접적으로 영향을 줄 수 있다는 것을 기억해 주세 요.",
      },
      {
        question: '우리 회사가 다른 회사에 비해 어떤 경쟁력을 가지고 있다고 생각하시나요?',
        guide:
          '지원 기업이 아니라 경쟁 회사에 대한 사전 조사, 그리고 시장에 대한 전반적인 이해는 면접의 전과정에서 매우 중요합니다. 특히, 이와 같은 질문은 지원자의 입사 의지를 간접적으로 확인하는 것으로 활용될 수 있다는 것도 기억하면 도움이 됩니다.',
      },
      {
        question: '앞으로 회사에서 어떻게 성장하고 싶은가요?',
        guide:
          '모든 회사에 적용할 수 있는 답변보다 지원 기업에 초점을 둔 답변을 한다면 도움이 됩니다. 지원기업의 현재와 미래의 주요 사업분야나 비전을 미리 확인하면 좋습니다. 특히, 개인의 발전 뿐만 아니라 자신이 기여할 수 있는 것에 초점을 두면 좋습니다.',
      },
    ],
  },
  [EJobType.FINANCE]: {
    knowledge: [
      {
        question: '가장 잘 알고 있는 금융 지식에 대해 설명해 주세요.',
        guide:
          '어떤 주제를 답변 할 것인지 선택하는 것이 중요합니다. 미리 업무 특성을 파악해둔다면, 면접관이 기대하는 지식을 알 수 있습니다. 답변할 때는 단순히 암기한 지식을 나열하는 것보다 간명하게 설명하고, 자신의 생각을 곁들여도 도움이 됩니다.',
      },
      {
        question: '지원분야에서 일을 하기 위해 준비한 것에 대해 말씀해 주세요.',
        guide:
          '어떤 준비를 했는지보다 현재 어느 정도 수준인지를 전달하는 것이 필요합니다. 자신의 노력을 강조하기 위해 경험과 활동을 전달하는 것에 집중하다보면, 결과적으로 면접관이 능력을 파악하는 것이 어려울 수 있습니다.',
      },
      {
        question: '금융 상품을 선택할 때 가장 중요한 것은 무엇인가요?',
        guide:
          '구체적인 고객의 페르소나를 상정하고 답변을 하는 것도 도움이 될 수 있습니다. 막연하고 원론적인 답변을 피할 수 있기 때문입니다. 고객 관점에서 지식을 얼마나 활용할 수 있는지를 전달하는데 초점을 두면 좋습니다.',
      },
    ],
    attitude: [
      {
        question: '당신의 현재 가치를 금전적으로 환산한다면 얼마일까요?',
        guide:
          '지원분야에서 가치를 부여하는 방법에 대해 고민을 하는 것이 좋습니다. 자신의 지식과 결합하여 스스로를 설명하는 것이 도움이 됩니다. 예를 들어 영업이익률이 가치를 산정하는데 중요하다면, 비유적으로 설명하는 것을 시도하는 것도 괜찮습니다.',
      },
      {
        question: '본인의 투자 경험에 대해서 말씀해 주세요.',
        guide:
          '지원분야에 따라 투자가 아닌 다른 경험을 물어볼 수 있습니다. 중요한 것은 앞으로 해야 할 일에 대한 관심과 경험이 있는지 입니다. 직접적인 업무 경험이 아니라도 지원분야에서 하게 될 일에 대한 활동을 미리 해보면 도움이 됩니다.',
      },
      {
        question: '본인은 어떤 성향의 사람이라고 생각하시나요?',
        guide:
          '지원 기업과 직무에 적합한지를 확인하는 것이기 때문에 이를 고려하는 것이 필요합니다. 단, 성급하게 기대하는 답변을 예상하여 자신과 다른 성향을 말하는 것은 적절하지 않습니다. 합격을 위해서가 아니라 정말 잘 맞는지 미리 고민하는 것이 좋습니 다.',
      },
    ],
  },
  [EJobType.DESIGN]: {
    knowledge: [
      {
        question: '자신의 성과/결과물에 대해 자랑해주세요.',
        guide:
          '디자인 직군에서 포트폴리오는 매우 중요합니다. 결과물 자체를 보여주는 것도 중요하지만, 그것을 표현하는 것도 중요합니다. 따라서 자신의 결과물을 잘 설명할 수 있는 준비와 연습이 반드시 필요합니다.',
      },
      {
        question: '가장 잘 할 수 있는 디자인과 도구는 무엇인가요?',
        guide:
          '디자인과 도구를 다루는 능력을 면접에서 보여주는 것은 쉽지 않습니다. 면접관들도 답변만 듣고 판단하기 어렵습니다. 따라서 구체적인 사례 또는 능력의 기준을 먼저 말한 뒤에 설명하는 것이 도움이 될 수 있습니다.',
      },
      {
        question: '고객의 요구를 가장 잘 반영 할 수 있는 방법은 무엇일까요?',
        guide:
          '디자이너의 고객은 여러 사람이 있습니다. 내부와 외부의 고객들을 모두 고려해야 합니다. 이와 같은 현실적인 상황을 상상하면서, 각 고객들의 입장에서 기대하는 것이 무엇일지를 염두에 두고 답변을 하면 좋습니다.',
      },
    ],
    attitude: [
      {
        question: '가장 좋아하는 디자이너는 누구이며, 그 이유는 무엇인가요?',
        guide:
          '면접관들 입장에서 좋아하는 디자이너는 지원자의 디자인적 지향점을 보여준다고 여겨집니다. 따라서 해당 디자이너의 디자인에 대한 자신의 생각을 잘 설명하면 좋습니다. 또한 좋아한다면 잘 알아야 한다는 느낌이 들기 때문에 정확하게 파악해두면 도 움이 됩니다.',
      },
      {
        question: '좋은 디자인이란 무엇이라고 생각하나요?',
        guide:
          '정해진 답은 없지만 지원 기업에서 어떤 디자인을 하고 있는지 곰곰이 생각해보면 도움이 됩니다. 결국 함께 일하고 싶고, 일할 수 있는 사람인지를 판단하기 위한 정보이기 때문입니다. 단, 실제 자신의 생각을 이야기하는 것이 진정성 있게 느껴질 것입니다.',
      },
      {
        question: '어떤 방식으로 아이디어를 떠올리나요?',
        guide:
          '아이디어를 떠올리는 방법에 정답은 없습니다. 다만, 디자인을 잘하기 위해서 평소에 어떤 준비를 하고 있는지 잘 설명하는 것이 좋습니다. 정답을 맞추기 위한 답변이 아니라 어떤 생각의 흐름으로 아이디어를 도출하는지에 대한 경험을 이야기 해주세요.',
      },
    ],
  },
};

export interface IJobData {
  job: string;
  desc: string;
}

export const jobData: Record<EJobType | number, Array<IJobData>> = {
  [EJobType.BUSINESS_MANAGEMENT]: [
    {
      job: '경영 기획',
      desc: '관리자를 지원하기 위해 경영 비전/방침과 장/단기 전략을 수립하여, 효율적이고 원활한 경영이 이루어지도록 관리합니다.',
    },
    {
      job: '회계/재무/세무',
      desc: '기업의 재무부서 운영을 기획/지휘/조정하고, 사업체의 재무 거래에 대해 분기/전기/결산 등의 업무를 수행합니다.',
    },
    {
      job: '인사',
      desc: '직원의 채용/배치/전환/퇴직/인사고과/담당 섭외 등의 업무를 기획/집행하고, 복리후생 및 노무 관련 업무를 수행합니다.',
    },
    {
      job: '법무/감사',
      desc: '기업 내 법적 업무를 맡아 법률과 관련된 제반 업무를 수행하고, 효율적인 감사를 위해 감사 실시에 따른 업무를 수행합니다.',
    },
    { job: '행정/사무지원', desc: '기업의 운영에 필요한 각종 행정 업무 및 관련된 제반 업무를 수행합니다.' },
    {
      job: '설비/안전',
      desc: '기업 운영에 필요한 각종 시설/설비와 소요물품을 관리하고, 이를 효율적으로 운영하기 위한 기획 및 조정 업무를 수행합니다.',
    },
    {
      job: '전산 관리',
      desc: '정보통신 전산 부서에서 기업 운영에 필요한 전산 장비 및 프로그램/운영체제를 관리하고 도입과 운영에 관련된 사항을 기획/실행합니다.',
    },
    {
      job: '비서',
      desc: '상사가 최적의 조건에서 최고의 업무 성과와 효율을 낼 수 있도록 일정을 계획/관리/조정하는 업무를 수행합니다.',
    },
  ],
  [EJobType.MARKETING]: [
    {
      job: '마케팅 전략/분석',
      desc: '시장 동향/미래 현황/경쟁업체 등 관련 데이터들을 수집/분석/평가하여 상품을 기획하거나 마케팅 계획 및 전략을 수립합니다.',
    },
    { job: '마케팅 콘텐츠', desc: '제품/서비스를 홍보하기 위한 마케팅 관련 업무를 수행합니다.' },
    {
      job: '홍보/광고/PR',
      desc: '제품/서비스에 대한 마케팅/광고/홍보의 필요성을 분석하고, 광고 행사를 기획/감독/조정하는 업무를 수행합니다.',
    },
    {
      job: '기타 마케팅',
      desc: '마케팅 전략분석/콘텐츠 제작/홍보 등을 제외한 기타 마케팅 업무로 컨벤션 또는 세미나 등을 기획하고 전반적인 운영을 실행하는 업무를 수행합니다.',
    },
  ],
  [EJobType.SALES]: [
    {
      job: '영업관리/지원',
      desc: '기업 영업부서의 운영을 기획/지휘하거나 영업 활동에 관련된 제반 관리 업무를 수행합니다.',
    },
    {
      job: '기술영업',
      desc: '기술에 관한 전문적 지식을 활용하여, 기계/장비/설비 등을 판매하고 고객에게 기술적인 지도를 수행합니다.',
    },
    {
      job: '일반영업',
      desc: '각종 제품과 서비스를 판매하기 위해 제품 및 광고를 영업하고, 감독 기능을 함께 수행합니다.',
    },
    {
      job: '특수영업(중개 등)',
      desc: '각종 제품의 등급과 품질을 파악하여, 생산자와 구매자 간의 거래가 이루어질 수 있도록 제품을 중개하는 역할을 수행합니다.',
    },
  ],
  [EJobType.PRODUCTION_MANAGEMENT]: [
    {
      job: '생산관리',
      desc: '효율적인 제품 생산을 위해 기업의 설비/원자재/종업원을 합리적으로 계획하고, 계획대로 실행될 수 있도록 현장을 관리합니다.',
    },
    {
      job: '공정관리/생산기술',
      desc: '각 분야의 생산 공정을 연구하며, 공정계획/공정 기술에 대하여 계획/설계/개발/개선하는 업무를 수행합니다.',
    },
    {
      job: '유통관리',
      desc: '제품이나 서비스가 고객에 도달하기까지 물류를 가장 효율적으로 운영할 수 있는 방법을 계획/실행하는 업무를 수행합니다.',
    },
    {
      job: '원자재/구매/재고',
      desc: '제품 생산에 필요한 각종 자재를 생산부서에 효율적으로 공급하기 위해 계획을 세워 구매하고 보관합니다.',
    },
    {
      job: '생산',
      desc: '제품 생산부서에서 육체노동을 이용해 직접 제품을 생산하거나 생산 기기를 조작하는 역할을 수행합니다.',
    },
    {
      job: '물류/운송',
      desc: '원료/제품/서비스를 공장이나 소비자에게 전달시키는 과정에 필요한 수송/하역/포장 등의 업무를 수행합니다.',
    },
    {
      job: '품질관리',
      desc: '제품 생산의 전반적인 과정에서 제품 규격의 표준화 달성, 품질 개선, 생산성 향상 등을 목표로 한 업무를 수행합니다.',
    },
    { job: '수출입/관세', desc: '제품/상품의 통관 및 수출입 계약 거래 등에 관한 사무적인 업무를 수행합니다.' },
  ],
  [EJobType.CONSTRUCTION]: [
    { job: '건축/건축공학', desc: '건축물의 설계 또는 공사 감독 업무를 수행합니다.' },
    {
      job: '토목/도시/교통',
      desc: '도시 건설에 필요한 토목/교량/제방/항만/철도/상하수도 등을 설계하거나 공사 감독 업무를 수행합니다.',
    },
    {
      job: '측량/지리 정보',
      desc: '토목건설/지리정보개발 등 지형/지물을 측량하여 계획/분석/평가/연구 등의 업무를 수행하며, 측량사 및 측량 보조원의 활동을 감독/조정합니다.',
    },
    {
      job: '주거/조경',
      desc: '공원/위락시설/공공건물/계획 단지 등의 각종 조경을 설계하고 공사 감독 업무를 수행합니다.',
    },
    {
      job: '플랜트',
      desc: '생산기업의 설비 또는 시설과 기능을 최고로 유지하여 기업의 수익을 높이기 위해, 설계/설치/활용/유지/보전 등 각 단계의 기술을 연구하는 업무를 수행합니다.',
    },
  ],
  [EJobType.RND]: [
    {
      job: '기계/자동차/조선',
      desc: '기계 공학의 지식을 활용하여, 로봇/자동차/조선 등 응용 분야에 대한 연구 및 신제품 개발 등의 업무를 수행합니다.',
    },
    {
      job: '금속/재료',
      desc: '재료의 개발 및 생산을 위해 재료의 속성 및 특성에 대해 연구하고, 신제품 계획/설계/개발 등의 업무를 수행합니다.',
    },
    {
      job: '전기/전자/제어',
      desc: '공학 기술을 바탕으로 전기제품/부품/장비 등을 설계 또는 개발하여, 기술적으로 검증 후 양산용 도면을 작성합니다.',
    },
    {
      job: '화학/고분자',
      desc: '각종 화학제품 원료를 시험/분석 후 새로운 제품/도구를 생산하여, 제품을 개량하거나 신제품을 개발합니다.',
    },
    {
      job: '에너지/환경/자원',
      desc: '에너지 및 환경 산업 분야의 기술 조건을 분석하고 안전성 및 신뢰성 등을 연구하여, 관련 시스템의 방법론을 수립하고 장비를 설계/개발합니다.',
    },
    {
      job: '인문/사회',
      desc: '다양한 인문/사회 분야에 대한 자료를 분석하고, 이론 및 방법론에 대한 개선/발전 연구를 수행합니다.',
    },
    {
      job: '생명/의료/식품',
      desc: '과학 및 공학 원리를 활용하여, 생물체의 기관/조직 또는 생명활동과 연관된 연구/개발 업무를 수행합니다.',
    },
    { job: '순수과학', desc: '물리/수학/지질학 등 순수과학 또는 자연과학 분야의 연구/개발 업무를 수행합니다.' },
    {
      job: '기타연구/개발',
      desc: '섬유공학/식품공학/산업안전/제도사 등 다양한 산업 군의 공학 기술을 연구/개발 업무를 수행합니다.',
    },
  ],
  [EJobType.IT]: [
    {
      job: '웹/SW 기획',
      desc: '웹 또는 OS 기반의 소프트웨어 서비스에 대한 기술적 검토/운영 및 서비스 활성화/사용자의 요구 사항 반영 등의 업무를 기획/관리합니다.',
    },
    {
      job: '시스템운영',
      desc: '클라이언트/서버/인터넷 및 인트라넷 형태의 전산망에 대해, 정보 보안 및 운영 관리 등의 업무를 수행합니다.',
    },
    {
      job: '품질관리',
      desc: '소프트웨어 등 IT 제품의 출시에 앞서 테스트를 수행하여 문제점, 보완점 등을 평가하거나 출시 제품의 품질에 대해 관리합니다.',
    },
    {
      job: '웹 개발',
      desc: '데이터베이스/백엔드/프론트엔드 등 각종 웹서비스 관련 기능에 대한 설계 및 구현 업무를 수행합니다.',
    },
    { job: '응용SW개발', desc: '각종 응용 SW 분야의 컴퓨터 소프트웨어를 설계하고 개발합니다.' },
    {
      job: 'AI/빅데이터',
      desc: '대규모 데이터를 활용하여 다양한 인사이트를 도출하고, 새로운 부가가치를 창출하기 위한 일련의 데이터마이닝 및 프로그래밍 작업을 수행합니다.',
    },
  ],
  [EJobType.DESIGN]: [
    {
      job: '패션디자인',
      desc: '성별/연령별/기능별 등 다양한 시장조사와 패션 경향을 예측/분석하여, 소비자에게 적합한 각종 의류에 대한 디자인 업무를 수행합니다.',
    },
    {
      job: '산업디자인',
      desc: '산업에 의해 대량생산되는 다양한 제품들이 기능성과 소비자의 취향을 만족할 수 있도록, 디자인 전략을 수립하고 관련된 업무를 수행합니다.',
    },
    {
      job: '실내장식 디자인',
      desc: '상가/주택 등 건물 내부 공간의 용도에 알맞게 구조/시설/가구/장식 등을 미학적으로 구성하여 디자인하는 업무를 수행합니다.',
    },
    {
      job: '시각디자인',
      desc: '컴퓨터 그래픽 기술을 이용해, 다양한 정보가 시각적으로 효율적으로 전달될 수 있도록 이미지를 도안하고 표현하는 업무를 수행합니다.',
    },
    {
      job: '미디어 디자인',
      desc: '음성·문자·그림·동영상 등 다양한 형식의 정보를 사용자가 용이하게 접근할 수 있는 환경인 웹사이트 등 다양한 매체를 통해 전달할 수 있도록 표현하는 업무를 수행합니다.',
    },
  ],
  [EJobType.FINANCE]: [
    {
      job: '금융상품 판매',
      desc: '고객을 상대로 금융 관련 서비스를 제공하거나, 고객에게 적합한 금융 상품들을 홍보/판매하는 업무를 수행합니다.',
    },
    {
      job: '금융상품 개발',
      desc: '은행/증권회사/우체국 등의 금융기관에서 예금/적금/주식 등의 금융상품을 개발하는 업무를 수행합니다.',
    },
    {
      job: '투자/신용분석',
      desc: '자신의 회사 또는 고객들에게 신용자료 및 관련 금융자료를 기반으로 국내 외 금융시장의 위험 요소를 파악/분석/통제하여, 전문적인 의견을 제공하는 업무를 수행합니다.',
    },
    {
      job: '자산운용',
      desc: '투자신탁/연금 등의 기관 투자가 또는 개인투자가의 자산이 최대수익을 올릴 수 있도록 금융자산을 관리/운용하고 투자자에게 투자전략에 대한 계획 및 정보를 제공합니다.',
    },
    {
      job: '보험상품 판매',
      desc: '보험 가입 대상자에게 적합한 보험상품을 안내하고 계약을 체결하는 업무를 수행합니다.',
    },
    {
      job: '보험상품 개발',
      desc: '보험회사의 전반적인 위험을 분석/평가/진단하여, 보험 상품에 대한 개발 인허가 업무와 보험료 및 책임준비금 등을 산출합니다.',
    },
    {
      job: '손해사정',
      desc: '보험 사고로 발생한 손해가 보험의 목적에 해당되는지 파악 후, 보상청구에 대해 심사하고, 사고 원인을 조사하여, 적정한 보험금을 산출/지급 허가를 하는 업무를 수행합니다.',
    },
  ],
  [EJobType.CUSTOMER_SUPPORT]: [
    {
      job: '오프라인 고객지원',
      desc: '오프라인 매장이나 행사장에서 상품을 판매하고 응대와 서비스를 제공하는 업무를 수행합니다.',
    },
    {
      job: '온라인 고객지원',
      desc: '전화/컴퓨터를 이용하여, 상품/서비스를 홍보/판매하거나 각종 민원사항에 응대하고 관련된 업무를 수행합니다.',
    },
    {
      job: '기타 서비스',
      desc: '고객과 직접적으로 소통하지는 않으나, 고객에게 가치를 줄 수 있는 서비스와 기술을 제공하는 업무를 수행합니다.',
    },
  ],
  [EJobType.HEALTHCARE]: [
    { job: '의료기사', desc: '의사의 지도하에 진료나 의화학적 검사를 수행합니다.' },
    {
      job: '간호조무',
      desc: '각종 의료기관에서 의사와 간호사의 지시/감독하에 간호 및 진료에 관련된 보조 업무를 수행합니다.',
    },
    { job: '보건지원', desc: '고객의 건강을 보전/증진 시키기 위해 필요한 다양한 업무를 수행합니다.' },
    {
      job: '약무',
      desc: '의사의 처방 또는 환자의 상태에 따라 병용 금지나 투약 금지 약물 등에 대한 검토 후 처방에 따라 조제/판매하고, 복약지도 등의 업무를 수행합니다.',
    },
    {
      job: '영양사',
      desc: '질병예방/건강증진/질병 치료를 위해 개인/단체에 적합한 영양 서비스를 제공하는 것을 목적으로, 식단을 계획하고 조리/공급을 감독하는 업무를 수행합니다.',
    },
    {
      job: '간호',
      desc: '의사의 진료를 보조하고, 의사의 처방이나 규정된 간호기술에 따라 환자를 치료/점검/기록하는 업무를 수행합니다.',
    },
  ],
};
